import * as cnUniApi from './cn-uni-api.js';
import { getButtonAction } from "@/common/manager/button";
import { ButtonPosition } from "@/type/button-position";
import { executeFunction } from "@/common/util/util";
const originalCnUniApi = window.cnUniApi || cnUniApi; // 兼容：优先用户script注入的cnUniApi
// 扩展 & 覆写
const overrideNavigateTo = originalCnUniApi.extend({
    // 浏览器环境覆写，其他环境照常。设计详见：https://alidocs.dingtalk.com/i/nodes/G1DKw2zgV2KnvL4kFpXq2jMoJB5r9YAn
    browser: (data) => {
        console.log("🚀 ~ file: lowcode-cn-uni-api.ts:8 ~ data:", data);
        const link = getButtonAction({
            optType: 'link',
            position: ButtonPosition.tableOperate,
        });
        executeFunction(link, data?._originConfig, {});
    },
    // dingtalk: (data) => {} // 如需扩展钉钉端。
}, originalCnUniApi.navigateTo);
// 覆写后的cnUniApi
export const CnUniApi = {
    ...originalCnUniApi,
    navigateTo: overrideNavigateTo,
};
